export enum CommonSliceType {
  SUBTITLE = 'subtitle',
  CHAPEAU = 'chapeau',
  HEADING = 'heading',
  TEXT = 'text',
  QUOTE = 'quote',
  LIST = 'list',
  FAQ = 'faq',
  INSERT = 'insert',
  HIGHLIGHTED = 'highlighted',
  FOOTNOTE = 'footnote',
  KEY_FIGURE_3 = 'key-figures-3',
  KEY_FIGURE = 'key-figure',
  CHILD_PUSHS = 'child_pushs',
  COLD_PUSH = 'cold_push',
  IMAGE_N_CAPTION = 'image',
  VIDEO_N_CAPTION = 'video',
  AUDIO_N_CAPTION = 'audio',
  IMAGE_N_TXT = 'image-text',
  VIDEO_N_TXT = 'video-text',
  AUDIO_N_TXT = 'audio-text',
  IMAGE_N_QUOTE = 'image-quote',
  VIDEO_N_QUOTE = 'video-quote',
  AUDIO_N_QUOTE = 'audio-quote',
  DOWNLOAD_LINK = 'download-link',
  CTA_LINK = 'cta-link',
  CONTACT = 'contact',
  COVER_CAROUSEL = 'cover-carousel',
}

enum _PostmenSliceType {
  POSTMEN_TITLE = 'postmen-title',
  STAFF_ILLUSTRATION = 'staff-illustration',
  QUOTES = 'quotes',
  PARITY_ILLUSTRATION = 'parity-illustration',
  TXT_ILLUSTRATIONS = 'txt-illustrations',
}

export type PostmenSliceType = CommonSliceType | _PostmenSliceType;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostmenSliceType = {
  ...CommonSliceType,
  ..._PostmenSliceType,
};
